import React from 'react';
import { useAuth } from './store';
import { SignedInView } from './components/SignedInView';
import { GuestIdleView } from './components/GuestIdleView';
import { LoginForm } from './components/LoginForm';
import { RegisterForm } from './components/RegisterForm';
import { ForgotPasswordForm } from './components/ForgotPasswordForm';
import { ResetPasswordForm } from './components/ResetPasswordForm';

export function AuthSection() {
  const authView = useAuth(s => s.authView);
  const user = useAuth(s => s.user);
  const isGuest = useAuth(s => s.isGuest);

  if (!!user && !isGuest) return <SignedInView />;
  if (authView === 'login') return <LoginForm />;
  if (authView === 'register') return <RegisterForm />;
  if (authView === 'forgot') return <ForgotPasswordForm />;
  if (authView === 'reset') return <ResetPasswordForm />;
  return <GuestIdleView />;
}
